import React, { useEffect, useState } from "react";
import { useMyContext } from "../../store/ContextApi";
import { useNavigate } from "react-router-dom";
import InstructorDetail from "../Instructor/InstructorDetail";
import LearnerDetail from "../Learner/LeanerDetail";
import InstructorRegistration from "../Instructor/InstructorRegistration";
import LearnerRegistration from "../Learner/LearnerRegistration";

const EditProfile = () => {
  const { isInstructor, isLearner, isAdmin, token, currentUser } =
    useMyContext();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else if (token && currentUser) {
      setLoading(false);
    }
  }, [token, currentUser, navigate]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <p className="text-lg font-medium animate-pulse">
          Loading your profile...
        </p>
      </div>
    );
  }

  return (
    <div>
      {isInstructor && <InstructorRegistration />}
      {isLearner && <LearnerRegistration />}
      {/* Add conditional rendering for learner/admin here if needed */}
    </div>
  );
};

export default EditProfile;
